<template lang="pug">
    .header.text-center
      a.btn-back.text-dark(v-if="!noBack", @click="$emit('backSignal')")
        i.fa.fa-chevron-left
      router-link.btn-exit.mt-3.text-dark(:to="{name: 'home'}")
        i.fa.fa-times
      h1.my-1 {{ title }}
</template>

<script>
export default {
  name: 'EventFooter',
  props: [
    'title', 'noBack',
  ],
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
  .header{
    // height: $navbar-height;
    // height: $event-header-heigt;
    z-index: -10;
    // background-color: $primary;
    padding: 5px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    color: white;
    // border-radius: 0 0 -20% 20%;
    @include desktop{
      border-radius: 0;
    }
    h1{
      margin: 5px;
      color: rgba(black, 0.9);
    }
    .btn-exit{
      position: absolute;
      right: 20px;
    }
    .btn-back{
      position: absolute;
      left: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/structure/AppHeader.vue